import { store as acl } from "@/modules/acl";
import { store as auth } from "@/modules/auth";
import { store as users } from "@/modules/users";
import { store as estados } from "@/modules/estados";
import { store as municipios } from "@/modules/municipios";
import { store as pessoas_fisica } from "@/modules/pessoas_fisica";
import { store as pessoas_juridica } from "@/modules/pessoas_juridica";
import { store as conselhos } from "@/modules/conselhos";
import { store as comissoes } from "@/modules/comissoes";
import { store as conselheiros } from "@/modules/conselheiros";
import { store as secretarias_executivas } from "@/modules/secretarias_executivas";
import { store as mesas_diretoras } from "@/modules/mesa_diretora";
import { store as files } from "@/modules/files";
import { store as entidades } from "@/modules/entidades";
import { store as plenarias } from "@/modules/plenarias";
import { store as pautas } from "@/modules/pautas";
import { store as bibliotecas } from "@/modules/bibliotecas";
import { store as agendas } from "@/modules/agendas";
import { store as cms_pages } from "@/modules/cms_pages";

export default {
  acl,
  auth,
  users,
  estados,
  municipios,
  pessoas_fisica,
  pessoas_juridica,
  conselhos,
  comissoes,
  conselheiros,
  secretarias_executivas,
  mesas_diretoras,
  files,
  entidades,
  plenarias,
  pautas,
  bibliotecas,
  agendas,
  cms_pages
};
